// Packages
import Swiper from 'swiper';
import { Controller, EffectFade, Navigation as SwiperNavigation, Mousewheel as Mousewheel } from 'swiper/modules';
Swiper.use([Controller, EffectFade, SwiperNavigation, Mousewheel]);
import Vue from 'vue';

// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/events/forum-2024-after.scss';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Media
const media = {
  smMax: window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`),
  mdMin: window.matchMedia(`(min-width: ${BREAKPOINTS.mdMin})`),
  xxlMin: window.matchMedia(`(min-width: ${BREAKPOINTS.xxlMin})`),
};

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import BackgroundVideo from '~scripts/blocks/vue/BackgroundVideo.vue';

// Components
import '~scripts/components/modals';
import initTextAnimation from '~scripts/components/text-animation';
import SubscribeForm from '~scripts/components/vue/forms/SubscribeForm.vue';

// Media
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation(BREAKPOINTS.mdMin);

//
// BANNER
//
// Text animation
initTextAnimation('.js-banner-text-animation', media.mdMin);

//
// HUNTFLOW BLOCK ANIMATION
//
const handleHuntflowBlockAnimation = () => {
  const hunflowBlockAnimationEl = document.getElementById('huntflowBlockAnimation');
  const headerHeight = media.xxlMin.matches ? 72 : 64;

  scrollAnimationProgress(hunflowBlockAnimationEl, {
    getStart(el) {
      const rect = el.getBoundingClientRect();
      return rect.top + window.scrollY - window.innerHeight;
    },
    getEnd() {
      const huntflowBlock = document.getElementById('huntflowBlock');
      const rect = huntflowBlock.getBoundingClientRect();
      return huntflowBlock.offsetHeight + rect.top + window.scrollY - headerHeight;
    },
  });
};

handleHuntflowBlockAnimation();
media.xxlMin.addEventListener('change', handleHuntflowBlockAnimation);

//
// SPEAKERS SLIDER
//
const speakersSliderElement = document.querySelector('.js-speakers-slider');
let speakersSlider = null;

if (speakersSliderElement) {
  const handleSpeakersSliderInit = () => {
    if (speakersSlider) {
      speakersSlider.destroy();
    }

    speakersSlider = new Swiper(speakersSliderElement, {
      centeredSlides: true,
      grabCursor: true,
      initialSlide: 1,
      loop: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.js-speakers-slider .swiper-button-next',
        prevEl: '.js-speakers-slider .swiper-button-prev',
      },
      slidesPerView: 'auto',
      spaceBetween: media.smMax.matches ? 16 : 32,
      speed: 600,
    });
  };

  handleSpeakersSliderInit();
  media.smMax.addEventListener('change', handleSpeakersSliderInit);
}

//
// PLACE SLIDER
//
const placeSliderElement = document.querySelector('.js-place-slider');
let placeSlider = null;

if (placeSliderElement) {
  const handlePlaceSliderInit = () => {
    if (placeSlider) {
      placeSlider.destroy();
    }

    placeSlider = new Swiper(placeSliderElement, {
      centeredSlides: true,
      grabCursor: true,
      initialSlide: 1,
      loop: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.js-place-slider .swiper-button-next',
        prevEl: '.js-place-slider .swiper-button-prev',
      },
      slidesPerView: 'auto',
      spaceBetween: media.smMax.matches ? 16 : 32,
      speed: 600,
    });
  };

  handlePlaceSliderInit();
  media.smMax.addEventListener('change', handlePlaceSliderInit);
}

//
// PAST
//
new Vue({
  el: '#BackgroundVideo',
  name: 'BackgroundVideo',
  components: {
    BackgroundVideo,
  },
});

//
// BENEFITS
//
// Cards
let stopBenefitsItemsAnimation = [];

const handleBenefitsItemsAnimation = () => {
  const benefitsItems = document.querySelectorAll('.js-benefits-item');

  if (media.smMax.matches) {
    stopBenefitsItemsAnimation.forEach((stop) => stop());
  } else {
    stopBenefitsItemsAnimation = Array.from(benefitsItems, (benefitItem) => {
      return scrollAnimationProgress(benefitItem, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          return start + 100;
        },
      });
    });
  }
};

handleBenefitsItemsAnimation();
media.smMax.addEventListener('change', handleBenefitsItemsAnimation);

// Icons
let stopBenefitItemsAnimation = [];

const handleBenefitItemsAnimation = () => {
  const benefitItems = document.querySelectorAll('.js-benefit-item');

  if (media.smMax.matches) {
    stopBenefitItemsAnimation.forEach((stop) => stop());
  } else {
    stopBenefitItemsAnimation = Array.from(benefitItems, (benefitItem) => {
      return scrollAnimationProgress(benefitItem, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          return start + 300;
        },
      });
    });
  }
};

handleBenefitItemsAnimation();
media.smMax.addEventListener('change', handleBenefitItemsAnimation);

//
// TABS
//
const tabsLists = document.querySelectorAll('.js-tabs');
const tabsItems = document.querySelectorAll('.js-tab');

const setActiveTab = (tabs, tab = tabs[0]) => {
  // Active
  tabs.forEach((tab) => {
    if (tab.classList.contains('is-active')) {
      tab.classList.remove('is-active');
    }
  });

  tab.classList.add('is-active');

  // Contents
  tabsItems.forEach((tabItem) => {
    const id = tabItem.getAttribute('id');

    if (id === tab.dataset.tab) {
      tabItem.style.display = 'initial';
    } else {
      tabItem.style.display = 'none';
    }
  });

  // Caret
  const caret = tabs[0].querySelector('span');
  caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
  caret.style.width = `${Math.floor(tab.offsetWidth)}px`;
};

const handleTabsInit = () => {
  tabsLists.forEach((tabs) => {
    const tabsItems = tabs.querySelectorAll('li');

    tabsItems.forEach((tab) => {
      setActiveTab(tabsItems, tab[0]);

      tab.addEventListener('click', (e) => {
        e.preventDefault();

        setActiveTab(tabsItems, tab);
      });
    });
  });
};

handleTabsInit();
media.smMax.addEventListener('change', handleTabsInit);

const handleTabsResize = () => {
  tabsLists.forEach((tabs) => {
    const tabsItems = tabs.querySelectorAll('li');

    const caret = tabsItems[0].querySelector('span');

    tabsItems.forEach((tab) => {
      if (tab.classList.contains('is-active')) {
        caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
        caret.style.width = Math.floor(tab.offsetWidth) + 'px';
      }
    });
  });
};

window.addEventListener('resize', handleTabsResize);

//
// FOOTER
//
const body = document.body;
const main = document.getElementById('main');
const footer = document.getElementById('footer');
const headerHeight = 64;

const scroll = {
  handle() {
    const footerHeight = footer.offsetHeight;

    if (window.scrollY > main.offsetHeight) {
      requestAnimationFrame(() => {
        body.style.paddingBottom = null;
      });

      if (window.innerHeight > footerHeight) {
        footer.style.position = 'static';
      } else {
        footer.style.position = 'relative';
      }
    } else {
      body.style.paddingBottom = `${footerHeight}px`;
      footer.style.position = 'fixed';

      if (window.innerHeight > footerHeight) {
        footer.style.removeProperty('top');
        footer.style.bottom = '0';
      } else {
        footer.style.removeProperty('bottom');
        footer.style.top = `${headerHeight}px`;
      }
    }
  },
  on() {
    this.handle();

    document.addEventListener('scroll', this.handle);
    window.addEventListener('resize', this.handle);
  },
  off() {
    body.style.paddingBottom = null;
    footer.style.position = 'static';

    document.removeEventListener('scroll', this.handle);
    window.removeEventListener('resize', this.handle);
  },
};

// Scroll
window.addEventListener('DOMContentLoaded', () => {
  if (!media.smMax.matches) {
    scroll.on();
  }

  media.smMax.addEventListener('change', () => {
    if (!media.smMax.matches) {
      scroll.on();
    } else {
      scroll.off();
    }
  });
});

window.addEventListener('load', () => {
  if (!media.smMax.matches) {
    scroll.handle();
  }
});

// Animation
let stopFooterAnimation = null;

const handleFooterAnimation = () => {
  if (media.smMax.matches) {
    if (stopFooterAnimation && typeof stopFooterAnimation === 'function') {
      stopFooterAnimation();
    }
  } else {
    stopFooterAnimation = scrollAnimationProgress(body, {
      getStart() {
        const rect = main.getBoundingClientRect();
        return rect.bottom + (window.scrollY - window.innerHeight);
      },
      getEnd(el, start) {
        return start + footer.offsetHeight - headerHeight;
      },
      lerpValue: 1,
    });
  }
};

handleFooterAnimation();
media.smMax.addEventListener('change', handleFooterAnimation);

//
// VIDEO
//
async function initVKVideoApi() {
  return new Promise((resolve) => {
    const tag = document.createElement('script');
    tag.src = 'https://vk.com/js/api/videoplayer.js';
    tag.onload = resolve;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  });
}
initVKVideoApi();

//
// MODALS
//
document.addEventListener('open-modal', (e) => {
  const target = e.target;
  const id = target.id;

  if (id === 'openingVideo' || id === 'pastVideo') {
    const video = target.querySelector('.js-vk-video');
    const player = VK.VideoPlayer(video);

    try {
      player.play();
    } catch {
      console.warn('Video player is not ready');
    }
  }
});

document.addEventListener('close-modal', (e) => {
  const target = e.target;
  const id = target.id;

  if (id === 'openingVideo' || id === 'pastVideo') {
    const video = target.querySelector('.js-vk-video');
    const player = VK.VideoPlayer(video);

    player.pause();
  }
});

// Subscribe icons
let stopSubscribeScrollAnimation = null;

const handleSubscribePhotoAnimation = () => {
  const SubscribeAnimation = document.querySelector('.js-form-wrapper');

  if (mediaSm.matches) {
    if (stopSubscribeScrollAnimation && typeof stopSubscribeScrollAnimation === 'function') {
      stopSubscribeScrollAnimation();
    }
  } else {
    stopSubscribeScrollAnimation = scrollAnimationProgress(SubscribeAnimation, {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        return rect.top + window.scrollY - window.innerHeight;
      },
      getEnd(el, start) {
        return start + el.offsetHeight;
      },
    });
  }
};

handleSubscribePhotoAnimation();
mediaSm.addEventListener('change', handleSubscribePhotoAnimation);

//
// SUBSCRIBE FORM
//
const subscribeFormEl = document.querySelector('.js-subscribe-form');

new Vue({
  el: subscribeFormEl,
  components: {
    SubscribeForm,
  },
});

// Events
const subscribeForm = document.getElementById('subscribeForm');

subscribeForm.addEventListener('submit', (e) => {
  e.preventDefault();

  window.subscribeAfterNaem24();
});
